const theme = {
  colors: {
    bodyBackground: "#f6f3f0",
    boxBackground: "#fff",
    primary: "#f8761f",
    text: "#000",
    buttonText: "#fff",
    border: "#d8d8d8",
  },
  fontFamilyJA: "Noto Sans JP",
  fontFamilyEN: "Roboto",
}

const devices = {
  mobile: "(min-width: 480px)",
  tablet: "(min-width: 768px)",
  laptop: "(min-width: 1024px)",
}

export type ThemeType = typeof theme
export { devices, theme }
